import { connect } from 'react-redux';
import {
    addFavouriteBusinessUnit,
    fetchBusinessUnits,
    filterBusinessUnit,
    getAllBusinessUnit,
    getUnselectedAllBusinessUnit,
    handleBusinessUnitRequestClose,
    hideBusinessUnitLoader,
    showBusinessUnitLoader,
    onAddBusinessUnit,
    onAllBusinessUnitSelect,
    onBusinessUnitClose,
    onBusinessUnitSelect,
    onDeleteBusinessUnit,
    onFilterSelectedBusinessUnit,
    onFilterBusinessUnitOptionSelect,
    onSaveBusinessUnit,
    onToggleBusinessUnitDrawer,
    updateSearchBusinessUnit,
} from 'actions/businessUnit';

import Component from './component';


export const mapStateToProps = ({ businessUnits, settings }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        businessUnit,
        searchBusinessUnit,
        filterOption,
        allBusinessUnit,
        businessUnitList,
        selectedBusinessUnit,
        selectedBusinessUnits,
        addBusinessUnitState
    } = businessUnits;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        businessUnit,
        searchBusinessUnit,
        filterOption,
        allBusinessUnit,
        businessUnitList,
        selectedBusinessUnit,
        selectedBusinessUnits,
        addBusinessUnitState
    };
};
export default connect(mapStateToProps, {
    fetchBusinessUnits,
    addFavouriteBusinessUnit,
    onBusinessUnitSelect,
    onAddBusinessUnit,
    onBusinessUnitClose,
    onFilterBusinessUnitOptionSelect,
    onSaveBusinessUnit,
    onDeleteBusinessUnit,
    onFilterSelectedBusinessUnit,
    filterBusinessUnit,
    getAllBusinessUnit,
    getUnselectedAllBusinessUnit,
    onAllBusinessUnitSelect,
    updateSearchBusinessUnit,
    onToggleBusinessUnitDrawer,
    handleBusinessUnitRequestClose,
    hideBusinessUnitLoader,
    showBusinessUnitLoader,
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/businessUnit/container.js